import React from 'react';
import PropTypes from 'prop-types';

const FlatButton = props => {
  const { className = '', icon, iconAlign = 'right', ...rest } = props;

  const finalClassName = className ? `flat-button ${className}` : 'flat-button';

  return (
    <div className={finalClassName} {...rest}>
      <div className="flat-content">
        {icon && iconAlign === 'left' && (
          <div className="flat-icon">
            <i className={`zmdi zmdi-${icon}`} />
          </div>
        )}
        {props.children && <div className="flat-label">{props.children}</div>}
        {icon && iconAlign === 'right' && (
          <div className="flat-icon">
            <i className={`zmdi zmdi-${icon}`} />
          </div>
        )}
      </div>
    </div>
  );
};

FlatButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  iconAlign: PropTypes.string,
  children: PropTypes.any,
};

export default FlatButton;
